module.exports = __webpack_public_path__ + "static/media/SlotsTopImage.df7edec3.jpg";